export default function Footer({ content }) {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--border)] mt-16 py-12 px-6 md:px-12 lg:px-24">
      <div className="flex flex-col md:flex-row justify-between items-start gap-8">
        <div>
          <p className="font-display text-2xl">{content?.artisan_name || "Sacred Instruments"}</p>
          <p className="text-sm text-[var(--text-secondary)] mt-2 max-w-sm">
            {content?.hero_tagline || "Crafted by hand. Tuned by spirit."}
          </p>
        </div>
        <div className="text-sm text-[var(--text-secondary)]">
          {content?.contact_email && (
            <p data-testid="footer-email">{content.contact_email}</p>
          )}
          {content?.contact_location && (
            <p className="mt-1">{content.contact_location}</p>
          )}
        </div>
      </div>
      <div className="divider-line my-8" />
      <p className="text-xs text-[var(--text-secondary)] tracking-wider">
        © {year} {content?.artisan_name || "Sacred Instruments"} · All instruments handmade with care.
      </p>
    </footer>
  );
}
